/**
 * Shared types and utilities for the encounter audits table layout.
 *
 * Layout modes control which columns are visible at different screen widths:
 * - full    (xl, >= 1536px): All columns
 * - standard (lg, 1200-1535px): Drop Quality
 * - compact  (md, 900-1199px): Drop Billing Codes, Service Type, Quality
 * - card     (< 900px): Stacked card layout
 */

/** Layout mode for the encounters table */
export type TableLayoutMode = 'full' | 'standard' | 'compact' | 'card';

/** Shared grid gap value (MUI spacing units) */
export const GRID_GAP = 2;

/**
 * Returns the CSS Grid `gridTemplateColumns` value for a given layout mode.
 *
 * Column order by layout:
 *   full:     Icon(40) Date(120) Clinician(1fr) Patient(1fr) ServiceType(1fr) Billing(140) Status(72) Compliance(90) Quality(72) Chevron(36)
 *   standard: Icon(40) Date(100) Clinician(1fr) Patient(1fr) ServiceType(1fr) Billing(130) Status(72) Compliance(80) Chevron(36)
 *   compact:  Icon(40) Date(100) Clinician(1fr) Patient(1fr) Status(72) Compliance(90) Chevron(36)
 *   card:     Not applicable (returns empty string)
 */
export function getGridTemplateColumns(layout: TableLayoutMode): string {
  switch (layout) {
    case 'full':
      return '40px 120px 1fr 1fr 1fr 140px 72px 90px 72px 36px';
    case 'standard':
      return '40px 100px 1fr 1fr 1fr 130px 72px 80px 36px';
    case 'compact':
      return '40px 100px 1fr 1fr 72px 90px 36px';
    case 'card':
      return '';
  }
}
